import * as React from 'react';
import styled from 'styled-components';
import { greyColour, tabletPortraitMinWidth } from '../../cssConstants';
import ArrowRightSvg from '../../../images/arrowRight.svg';

const ViewAllButton = ({ buttonText = 'View all', onButtonClick, className }: Props) => {
	return (
		<StyledButton className={className} onClick={onButtonClick}>
			{buttonText} <StyledIcon src={ArrowRightSvg} />
		</StyledButton>
	);
};

export default ViewAllButton;

interface Props {
	buttonText?: string;
	onButtonClick: () => void;
	className?: string;
}

const StyledButton = styled.button`
	font-size: 14px;
	font-weight: 500;
	line-height: 20px;
	letter-spacing: 0.1px;
	color: ${greyColour};
	cursor: pointer;
	background: none;
	border: none;

	@media (min-width: ${tabletPortraitMinWidth}) {
		font-size: 16px;
		line-height: 24px;
	}
`;

const StyledIcon = styled.img`
	width: 16px;
	height: 16px;
	margin-left: 4px;
	vertical-align: middle;
`;
